"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgThermometerOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M9 4.5a.5.5 0 01.5.5v12.134a1 1 0 11-1 0V5a.5.5 0 01.5-.5z' }),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 15.354V5a3 3 0 10-6 0v10.354a4 4 0 106 0zm-2 .914V5a1 1 0 00-2 0v11.268A2 2 0 009 20a2 2 0 001-3.732z' }),
    react_1.default.createElement("path", { d: 'M19 7a3 3 0 11-6 0 3 3 0 016 0z' }))); };
exports.default = SvgThermometerOutline;
//# sourceMappingURL=ThermometerOutline.js.map